/**
 * A mixin for formatting select labels
 */
export default {
  methods: {
    getFormattedSelectLabel (item, label) {
      if (item.length === 0) return ''
      else return label
    },
    getFormattedSelectValue (item, label, max = 2) {
      if (item == null) return label
      else if (item.length === 0) return label
      else if (typeof item === 'string' && item != '') return item
      else if (item.length <= max) return item.take(item.length).map(x => x.name).join(', ')
      else return `${item.length} wybrano`
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/search/SelectLabelFormatter.js